import { useEffect, useState } from 'react';

import { callGetCollectionOwners } from '@app/client/resources/marketplace';

import { useCollectionContracts } from './useCollectionContracts';

export const useCollectionOwners = (slug?: string) => {
    const { data: collectionContractsData, isLoading: isLoadingContracts } = useCollectionContracts({ slug });

    const [isLoadingOwners, setIsLoadingOwners] = useState(false);
    const [owners, setOwners] = useState<string[]>([]);
    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        function getOwners(contract: string, continuation?: string) {
            setIsLoadingOwners(true);
            const query = { limit: 1000 };
            if (continuation) {
                query['continuation'] = continuation;
            }
            callGetCollectionOwners({ contract, query, settings: { signal } }).then((res) => {
                if (res.ok && res.value) {
                    setOwners((currOwners) => [...currOwners, ...res.value.wallets]);
                    if (res.value.continuation) {
                        getOwners(contract, res.value.continuation);
                    } else {
                        setIsLoadingOwners(false);
                    }
                }
            });
        }
        collectionContractsData?.contracts.forEach((contract) => getOwners(contract));

        return () => {
            controller.abort();
            setOwners([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [collectionContractsData?.contracts]);

    return {
        owners,
        setOwners,
        collectionContracts: collectionContractsData?.contracts,
        isLoading: isLoadingOwners || isLoadingContracts,
    };
};
